import React from 'react';

function CheckedSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#398300"
        d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm5.039 7.27l-5.836 6.329a1 1 0 01-.727.322h-.009c-.273 0-.534-.112-.723-.309l-2.081-2.178a1 1 0 011.445-1.382l1.346 1.408 5.113-5.545a1.001 1.001 0 011.472 1.355z"
      ></path>
    </svg>
  );
}

export default CheckedSvg;
